<template>
    <div class="transferencia-form">
        <div v-if="showFields">
        <p class="text-justify">Al presionar el botón “canjear” serás redireccionado al portal de canje de Cencosud, aquí podrás obtener tu código de canje. Una vez terminado el proceso, vuelve a esta página e ingresa el código obtenido.</p>
        <div
            ref="transferencia-form-form"
            novalidate
            :class="{
                'was-validated': validated
            }">
        <div   v-if="!isCompletedRedirect"
            @click="submit('rut')"
            class="form-group text-center">
                <button class="btn btn-primary w-100 btn-noradius" style="height: 45px;">
                    Canjear
                    <spinner v-if="isSubmitting" />
                </button>
            </div>
            <div class="form-group" >
                <input type="text"
                    class="form-control"
                    id="cencosud-form-codigo"
                    aria-describedby="codigoHelp"
                    placeholder="Ingrese su Código"
                    required
                    :readonly="!isCompletedRedirect"
                    v-model="codigo">
                <div class="invalid-feedback">Código inválido</div>
            </div>
            <div class="form-group text-center"
                v-if="isCompletedRedirect"
                @click="submit('pago') " >
                <button class="btn btn-primary w-100 btn-noradius" style="height: 45px;">
                    Confirmar
                    <spinner v-if="isSubmitting" />
                </button>
            </div>


            <div class="perfil-alert color-red"
                v-if="transferenciaMessage!=''">
                <font-awesome-icon
                    :icon="iconReturn"
                    :class="{'color-red':iconReturn!='check',
                    'color-green':iconReturn=='check'}" />
                    {{ transferenciaMessage }}
            </div>

        </div>
        </div>

    </div>
</template>

<script>
import Spinner from "./Spinner";
import { mapState, mapGetters } from "vuex";
import { rutEsValido } from "../utilities/util";
import {
	faCheck,
	faSpinner,
	faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";



export default {
	components: { Spinner,FontAwesomeIcon },
	props: ["id_compra","url_cencosud"],
	data() {
		return {
            codigo:"",
			validated: false,
			isSubmitting: false,
			transferenciaMessage: "",
			showFields: true,
            compraExito:false,
            isCompletedRedirect:false,
            iconReturn:""
		};
	},
    watch: {

    },

    computed: {
        RutLoad(){
            this.rut = this.user.rut;
            return this.user.rut;
        },

        isRutValid(){
            return rutEsValido(this.rut);
        },
        ...mapState(["portal", "user", "site", "isPortalReady"]),
		...mapGetters(["userId"])
    },
	methods: {

		submit(option) {

			this.validated = true;
            this.transferenciaMessage = "";


            if(option == "rut"){

                        this.isCompletedRedirect = true;
                        this.validated = false;

                        window.open(this.url_cencosud, '_blank');

                 return false;

		    }


/*
if(this.id_compra == 0){
            let postData = {
				codigo_descuento: this.codigo,
				id_producto: 0
			};
			this.descuentoMessage = "";

			this.$api
				.descuentos(postData)
				.then(response => {

                  document.querySelector("#pagar_curso").click();

                  return false;

				})
				.catch(error => {
					alert("Error");
					console.log(error);
                });

}else{*/

			if (this.codigo != "" && this.isCompletedRedirect && option == "pago" && this.id_compra!="") {

				this.isSubmitting = true;
				this.$store
					.dispatch("cencosud", {
						rut: "cencosud",
						codigo: this.codigo,
						id_compra: this.id_compra
					})
					.then(response => {
						console.log("response cencosud", response);
						this.transferenciaMessage =
							"Información registrada, tu pago se realizo con exito.";
						this.validated = false;
						this.$emit("ok", response);
						this.isSubmitting = false;
						this.nombre = "";
						this.numero = "";
						this.banco = "";
						this.showFields = false;
                        this.compraExito=true;

                        this.iconReturn = 'check';

						// Actualizar compras de usuario.
						this.$store.dispatch("getUserCompras").catch(error =>
							console.log("error getUserCompras", error)
						);

						// Cargar videos de usuario
						this.$store.dispatch("getUserVideos").catch(error =>
							console.log("error getUserVideos", error)
						);
						console.log("finish cencosud", response);

                    this.$router.push({
					name: "CheckoutFinish",
					params: {
						pasarela :"cencosub",
						estado: "aprobado",
						id_compra:this.id_compra,
					}
				});

					})
					.catch(error => {
						this.transferenciaMessage =
							"Error al registrar el pago, por favor intente de nuevo.";
						this.$emit("error", error);
                        this.isSubmitting = false;
                        this.iconReturn = 'exclamation-triangle';

					});
			} else {
                this.transferenciaMessage = "Debe completar los datos.";
                this.iconReturn = 'exclamation-triangle';

			}
        }

      //  }
	}
};
</script>

